import React, { useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { gsap, Power1 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useInView } from "react-intersection-observer";

gsap.registerPlugin(ScrollTrigger);

const Contact = () => {
  let reff = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    const element = reff.current;
    const container = element.querySelector(".container");
    const left = element.querySelector(".left");
    const right = element.querySelector(".right");

    gsap.fromTo(
      container,
      0.6,
      { y: -44, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: container,
          start: "top bottom-=10",
        },
      }
    );
    gsap.fromTo(
      left,
      0.6,
      { x: -44, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: left,
          start: "top bottom-=10",
        },
      },
      1.2
    );
    gsap.fromTo(
      right,
      0.6,
      { x: 44, opacity: 0 },
      {
        x: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: right,
          start: "top bottom-=10",
        },
      },
      1.4
    );
  }, []);

  useEffect(() => {
    const menu = document.querySelectorAll(".nav-link");
    if (inView) {
      menu[4].classList.add("active");
      menu[0].classList.remove("active");
      menu[1].classList.remove("active");
      menu[2].classList.remove("active");
      menu[3].classList.remove("active");
    }
  }, [inView]);

  return (
    <>
      <motion.section
        data-scroll-section
        initial={{ visibility: "hidden" }}
        animate={{ visibility: "visible", transition: { delay: 1 } }}
        exit={{ visibility: "hidden", transition: { delay: 1 } }}
        className="contactPage"
        ref={reff}
        id="contact"
      >
        <div className="container" ref={ref}>
          <div className="left">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27036.476827873732!2d76.3649795936774!3d32.108186195445576!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391b4c317292f6d5%3A0x7986b64ab27a0248!2sNagrota%20Bagwan%2C%20Himachal%20Pradesh%20176047!5e0!3m2!1sen!2sin!4v1623759904838!5m2!1sen!2sin"
              width="600"
              height="420"
              style={{ border: 0 }}
              loading="lazy"
              title="Address"
            ></iframe>
          </div>
          <div className="right">
            <h1>Get in touch-</h1>
            <div className="info">
              Feel free to get in touch with me. I am always open to discussing
              new projects, creative ideas and opportunities.
            </div>
            <p>
              <i className="fas fa-map-marker-alt address"></i>
              &nbsp;&nbsp;&nbsp; Nagrota Bagwan Distt. Kangra Himachal Pradesh
              ,India
            </p>
            <p>
              <i className="fas fa-envelope-open gmail"></i>
              <a
                href="mailto:akshitrana21@gmail.com?subject=Hello Akshit!"
                className="mail"
              >
                &nbsp;&nbsp;&nbsp;akshitrana21@gmail.com
              </a>
            </p>
            <div className="social">
              <a
                href="https://www.facebook.com/akshit.rana3"
                target={"_open"}
                className="fb"
              >
                <i className="fab fa-facebook" title="Facebook"></i>
              </a>
              <a
                href="https://www.linkedin.com/in/akshit-rana-10"
                target={"_open"}
                className="linkedIn"
              >
                <i className="fab fa-linkedin" title="Linked in"></i>
              </a>
              <a
                href="https://www.instagram.com/_akshit._.3010_"
                target={"_open"}
              >
                <i className="fab fa-instagram ig" title="Instagram"></i>
              </a>
              <a
                href="https://github.com/Akshit3010"
                className="git"
                target={"_open"}
              >
                <i className="fab fa-github" title="GitHub"></i>
              </a>
            </div>
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default Contact;
